
export const saveTokens = (tokens) => {
  localStorage.setItem('access_token', tokens.access_token);
  localStorage.setItem('refresh_token', tokens.refresh_token);
}

export const getTokens = () => {
  const access_token = localStorage.getItem('access_token');
  const refresh_token = localStorage.getItem('refresh_token');
  return { access_token, refresh_token };
}

export const resetTokens = () => {
  localStorage.setItem('access_token', '');
  localStorage.setItem('refresh_token', '');
}